import {TrackingPromotionCreative} from '@aboutyou/legacy-tracking-sdk';
import {TrackPromotions} from '@aboutyou/tracking';
import {
  mediaTabletAndUp,
  PreloadableImage,
  UnstyledLinkLinaria,
  useGetAriaLabelFromUrl,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {FC} from 'react';

interface LogoProps {
  targetUrl: string;
  promotionId: string;
  promotionName: string;
  imagePath: string;
  creativeName?: string;
}

export const BASCampaignHeaderLogo: FC<LogoProps> = ({
  targetUrl,
  promotionId,
  promotionName,
  imagePath,
  creativeName,
}) => {
  const getAriaLabelFromUrl = useGetAriaLabelFromUrl();
  return (
    <>
      {creativeName && <XContainer>x</XContainer>}
      <BASLogoWrapper
        to={targetUrl}
        data-testid="HeaderBASLogo"
        aria-label={getAriaLabelFromUrl(targetUrl)}
      >
        <StyledTrackPromotions
          data-testid="HeaderBASLogoTracked"
          promotion={{
            advertisement: {
              id: promotionId,
              path: targetUrl,
              name: promotionName,
              creativeName,
            },
            source: TrackingPromotionCreative.BasLogoIntegration,
          }}
          streamPosition={1}
        >
          <StyledPreloadableImage
            src={imagePath}
            importance="high"
            loading="eager"
            width="initial"
          />
        </StyledTrackPromotions>
      </BASLogoWrapper>
    </>
  );
};

const BASLogoWrapper = styled(UnstyledLinkLinaria)`
  display: var(--bas-takeover-icon-display, flex);
  align-items: center;
  padding: 2px;
  height: 26px;

  @media ${mediaTabletAndUp} {
    height: 35px;
  }
`;

const StyledTrackPromotions = styled(TrackPromotions)`
  display: flex;
  height: 100%;
`;

const XContainer = styled.div`
  display: var(--bas-takeover-icon-display, flex);
  justify-content: center;
  align-items: center;
  padding-right: 2px;
  padding-left: 4px;
`;

const StyledPreloadableImage = styled(PreloadableImage)`
  height: 100%;
  object-fit: contain;
  object-position: 0 center;
`;
